













































import Vue from "vue"
import { ParcelGoods } from "@/model/entity/shipment/parcel-goods"
import { ElementUIComponent } from "element-ui/types/component"
import ElementUI, { Form } from "element-ui"

export interface IFoodGroup extends Vue {
  getFood(): ParcelGoods

  setFood(parcelGoods: ParcelGoods): void

  clearAll(): void
}

export default Vue.extend({
  data() {
    const validateMinTemp = (rule, value, callback) => {
      if ((this as any).form.tempMax !== "" && value === "") {
        callback(new Error())
      } else {
        callback()
      }
    }
    const validateMaxTemp = (rule, value, callback) => {
      if ((this as any).form.tempMin !== "" && value === "") {
        callback(new Error())
      } else {
        callback()
      }
    }
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          const millisecondsOfDay = 8.64e7
          return time.getTime() <= Date.now() - millisecondsOfDay
        }
      },
      form: {
        limitDate: "",
        tempMin: "",
        tempMax: "",
        description: ""
      },
      rules: {
        limitDate: [
          {
            required: true,
            message: this.$t("new.parcel.error.food.limit_date").toString(),
            trigger: "change"
          }
        ],
        tempMin: [
          {
            validator: validateMinTemp,
            message: this.$t("new.parcel.error.goods_temp_mandatory").toString(),
            trigger: "blur"
          }
        ],
        tempMax: [
          {
            validator: validateMaxTemp,
            message: this.$t("new.parcel.error.goods_temp_mandatory").toString(),
            trigger: "blur"
          }
        ],
        description: [
          {
            required: false,
            message: this.$t("new.parcel.error.food.description").toString(),
            trigger: "change"
          }
        ]
      }
    }
  },
  props: {
    foodValidated: {
      type: Boolean,
      required: true
    },
    isFoodProduct: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clearAll() {
      this.form = {
        limitDate: "",
        tempMin: "",
        tempMax: "",
        description: ""
      }
    },
    getFood(): ParcelGoods {
      return new ParcelGoods(
        this.form.limitDate,
        this.form.tempMin ? this.processTemp(this.form.tempMin) : "",
        this.form.tempMax ? this.processTemp(this.form.tempMax) : "",
        this.form.description
      )
    },
    setFood(parcelGoods: ParcelGoods) {
      this.form.limitDate = parcelGoods.limitDate
      this.form.tempMin = parcelGoods.tempMin
      this.form.tempMax = parcelGoods.tempMax
      this.form.description = parcelGoods.description
    },
    emitValidation() {
      (this.$refs.form as Form).validate(passed => {
        this.$emit("update:foodValidated", !this.isFoodProduct || passed)
      })
    },
    processTemp(inputTemp: string): string {
      const delimiter = "."
      if (inputTemp.includes(delimiter)) {
        if (inputTemp.split(delimiter)[1].length !== 2) {
          const decimalPart = inputTemp
            .split(delimiter)[1]
            .concat("00")
            .slice(0, 2)
          return inputTemp.split(delimiter)[0].concat(delimiter, decimalPart)
        }
        return inputTemp
      }
      return inputTemp.concat(delimiter, "00")
    }
  },
  watch: {
    "form.limitDate": {
      handler() {
        this.emitValidation()
      }
    },
    "form.tempMin": {
      handler() {
        this.emitValidation()
      }
    },
    "form.tempMax": {
      handler() {
        this.emitValidation()
      }
    },
    "form.description": {
      handler() {
        this.emitValidation()
      }
    },
    isFoodProduct: {
      handler() {
        this.emitValidation()
      }
    }
  },
  mounted() {
    this.emitValidation()
  }
})
